export class SignUpPopup {
    constructor() {
        this.$popup = $('.c-signup-popup');
        const $close = $('.js-close-signup-popup');
        const timeout = this.$popup.data('timeout');

        // bind events
        $close.on('click', () => this.close());

        if (this.$popup.length > 0) this.init(timeout);
    }

    init(timeout) {
        setTimeout(() => {
            this.show();
        }, timeout * 1000)
    }


    show() {
        this.$popup.show();
    }

    close() {
        this.$popup.fadeOut();
    }
}
